import { render, staticRenderFns } from "./ProductsFilterModal.vue?vue&type=template&id=1153b800&"
import script from "./ProductsFilterModal.vue?vue&type=script&lang=ts&"
export * from "./ProductsFilterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports